export class ApiError extends Error {
  fields?: Record<string,string[]>;
  constructor(message:string, fields?:Record<string,string[]>) { super(message); this.fields=fields; }
}

export async function api<T>(path:string, options:RequestInit={}) {
  const isForm = options.body instanceof FormData;
  const response = await fetch(`/api${path}`, { credentials:'include', ...options, headers:{ ...(isForm?{}:{'Content-Type':'application/json'}), ...options.headers } });
  if (response.status === 204) return undefined as T;
  const data = await response.json().catch(()=>({}));
  if (!response.ok) throw new ApiError(data.error || 'Request failed.', data.fields);
  return data as T;
}

export const money = (value:number,currency='PKR') => new Intl.NumberFormat('en-PK',{style:'currency',currency,maximumFractionDigits:0}).format(value);
const pakistanDayFormatter = new Intl.DateTimeFormat('en-GB',{timeZone:'Asia/Karachi',day:'2-digit',month:'short',year:'numeric'});
const pakistanCalendarFormatter = new Intl.DateTimeFormat('en-CA',{timeZone:'Asia/Karachi',year:'numeric',month:'2-digit',day:'2-digit'});
const pakistanTimestampFormatter = new Intl.DateTimeFormat('en-GB',{timeZone:'Asia/Karachi',day:'2-digit',month:'short',year:'numeric',hour:'2-digit',minute:'2-digit',hour12:true});
export const pakistanCalendarDate = (date:Date) => pakistanCalendarFormatter.format(date);

export const prettyDate = (value:string|null|undefined) => {
  if(!value)return 'Not assigned';
  const date=/^\d{4}-\d{2}-\d{2}$/.test(value)?new Date(`${value}T00:00:00+05:00`):databaseTimestamp(value);
  return Number.isNaN(date.getTime())?'Not assigned':pakistanDayFormatter.format(date);
};
export const pakistanToday = () => pakistanCalendarDate(new Date());
// SQLite CURRENT_TIMESTAMP is UTC but omits the ISO `Z`; make that UTC meaning explicit.
export const databaseTimestamp = (value:string) => new Date(/^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?$/.test(value)?value.replace(' ','T')+'Z':value);
export const initials = (name:string) => name.trim().split(/\s+/).slice(0,2).map(x=>x[0]).join('').toUpperCase();

export const pakistanDateTime = (value:string) => pakistanTimestampFormatter.format(databaseTimestamp(value))+' PKT';
